export enum CollaboratorLPPPlan {
  STANDARD = 'STANDARD',
  EXECUTIVE = 'EXECUTIVE',
}

export const getCollaboratorLPPPlanLabel = (
  plan: CollaboratorLPPPlan
): string => {
  switch (plan) {
    case CollaboratorLPPPlan.STANDARD:
      return $localize`Standard`;
    case CollaboratorLPPPlan.EXECUTIVE:
      return $localize`Cadre`;
    default:
      return plan;
  }
};
